





























	import { MyActions } from '@/models/Store/State';
	import Vue, { PropType } from 'vue';

    export default Vue.extend({
        name: "AnmeldungComp",
        props: {
			foreignAnmeldung: Object as PropType<any>
		},
        computed: {
            buttonValue: {
                get: function(): any {
                    if (this.foreignAnmeldung) {
                        return this.foreignAnmeldung;
                    }
					return this.$vStore.getters.anmeldung;
                },
                set: async function(type: any): Promise<void> {
                    if (this.foreignAnmeldung) {
                        this.$emit('anmelden', type);
                    } else {
						await this.$vStore.dispatch(MyActions.Anmelden, type);
                    }
                }
            }
        }
    })
